import { internationalWorksheetsUrl } from '../../../urls';

export const internationalWorksheetCollectionEmailsUrl = () =>
  `${internationalWorksheetsUrl()}/collection-emails`;
